import {
  createLogger,
  DEBUG,
  stdSerializers,
  Logger,
  WARN
} from 'browser-bunyan'
import { ConsoleFormattedStream } from '@browser-bunyan/console-formatted-stream'
import { getEnvironmentFromUrl, isProdEnvironment } from './app.config'

const initLogger = (): Logger =>
  createLogger({
    name: 'logger',
    streams: [
      {
        level: isProdEnvironment(getEnvironmentFromUrl()) ? WARN : DEBUG,
        stream: new ConsoleFormattedStream()
      }
    ],
    serializers: stdSerializers,
    src: true
  })

export const logger = initLogger()

logger.info('Logger initialized')
